export default class NoParserError extends Error {}
